<template>
  <component
    :is="type"
    :class="`headline font-bold font-cera-pro ${typographyClasses} ${cursoredClasses}`">
    <slot />
  </component>
</template>

<script>
import bemBlockMofifiers from "@/utils/bem-block-modifiers";

export const TYPES = ["h1", "h2", "h3", "h4", "h5", "div"];
export const TYPOGRAPHY = {
  h0: {
    default: "text-h0",
    responsive: "text-h2 m:text-h1 l:text-h0"
  },
  h1: {
    default: "text-h1",
    responsive: "text-h2 m:text-h1"
  },
  h15: {
    default: "text-h15",
    responsive: "text-h3 m:text-h2 l:text-h15"
  },
  h2: {
    default: "text-h2",
    responsive: "text-h3 m:text-h2"
  },
  h3: {
    default: "text-h3"
  },
  h35: {
    default: "text-h35"
  },
  h4: {
    default: "text-h4"
  },
  h5: {
    default: "text-h5"
  },
  h6: {
    default: "text-h6"
  }
};

export default {
  name: "Headline",
  props: {
    type: {
      type: String,
      default: "h2",
      required: true,
      validator: (value) => {
        return TYPES.includes(value);
      }
    },
    typography: {
      type: String,
      default: "h2",
      required: true,
      validator: (value) => {
        return Object.keys(TYPOGRAPHY).includes(value);
      }
    },
    responsive: {
      type: Boolean,
      default: true,
      required: false
    },
    cursored: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    typographyClasses() {
      const baseTypography = TYPOGRAPHY[this.typography];
      return this.responsive && baseTypography.responsive
        ? baseTypography.responsive
        : baseTypography.default;
    },
    cursoredClasses() {
      return this.cursored ? bemBlockMofifiers("headline", ["cursored"]) : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.headline {

  &--cursored {
    @include cursored;
  }
}
</style>
